import type { Properties } from "posthog-js"
import {
  appEventProperties,
  getClientContextProperties,
  getResolvedClientContext,
} from "@/lib/posthog/context"
import { getPostHogClient } from "@/lib/posthog/state"

export function syncPostHogRouteContext({
  clientId,
  route,
}: {
  clientId?: string
  route: string
}) {
  const client = getPostHogClient()
  if (!client) {
    return
  }

  const clientContext = getResolvedClientContext(clientId)
  client.register_for_session({
    route,
    ...getClientContextProperties(clientContext),
  })

  if (!clientId) {
    client.unregister_for_session("client_id")
    client.unregister_for_session("client_key")
    client.unregister_for_session("client_name")
  } else if (!clientContext?.name) {
    client.unregister_for_session("client_name")
  }
}

export function getPostHogPageviewProperties({
  clientId,
  route,
}: {
  clientId?: string
  route: string
}) {
  return appEventProperties({
    $current_url: window.location.href,
    route,
    ...getClientContextProperties(getResolvedClientContext(clientId)),
  }) satisfies Properties
}

export function getPostHogRoute() {
  return `${window.location.pathname}${window.location.search}`
}

export function getPostHogRouteClientId(pathname: string) {
  const match = pathname.match(/^\/app\/clients\/([^/]+)/)
  return match ? decodeURIComponent(match[1]) : undefined
}
